(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    class BackToTop extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const sentinel = this.querySelector('.back-to-top__sentinel');
      if (!button || !sentinel) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      const update = () => {
        button.hidden = sentinel.getBoundingClientRect().bottom >= 0;
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(update);
        this.observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', update, { passive: true, signal });
      }
      window.addEventListener('pageshow', update, { signal });
      update();

      button.addEventListener('click', () => {
        // Keep keyboard navigation at the start when this button becomes hidden.
        document.querySelector('body > .skip-to-content-link')?.focus({ preventScroll: true });
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
      }, { signal });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
  }

  if (!customElements.get('back-to-top')) {
    customElements.define('back-to-top', BackToTop);
  }
  } catch(e) { console.error(e); }
})();

})();
